<template>
  <div>
    <a href="https://www.bbb.org/us/ut/lehi/profile/loans/lendio-inc-1166-22173663/#sealclick" id="bbblink" class="ruhzbum" target="_blank" rel="nofollow">
      <img src="https://seal-utah.bbb.org/logo/ruhzbum/bbb-22173663.png" style="border: 0;" alt="Lendio, Inc. BBB Business Review" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'BBBWidget',
  setup() {
    useHead({
      script: [
        {
          src: "//seal-utah.bbb.org/inc/legacy.js",
        }
      ]
    })
  }
}
</script>

<style lang="scss" scoped>
  a#bbblink.ruhzbum {
    width: 100px;
    height: 45px;
    @include media-breakpoint-down(lg) {
      width: 115px;
      height: 55px;
    }
  }
  a#bbblink.ruhzbum:hover img {
    margin-left: -100px;
  }
</style>
